import { HoverCard } from '@mantine/core';
import { RunNote } from './RunNote';

export function RunNoteHoverCard({
  note,
  classNames,
  children,
}: {
  note: string;
  classNames?: {
    target?: string;
    dropdown?: string;
  };
  children: React.ReactNode;
}) {
  return (
    <HoverCard
      withArrow
      shadow="lg"
      width={350}
    >
      <HoverCard.Target>
        <div className={`relative z-10 ${classNames?.target ?? ''}`}>{children}</div>
      </HoverCard.Target>
      <HoverCard.Dropdown className={classNames?.dropdown}>
        <RunNote note={note} />
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
